module.exports = "<footer class=\"main-footer\">\r\n  <div class=\"text-center\">\r\n    Viera Builders ©{{currentyear}}\r\n  </div>\r\n\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/components/footer/footer.component.html
// module id = ./src/app/containers/layout/components/footer/footer.component.html
// module chunks = main